import { IconEventType } from "pages/home/components/icons/FirstSteps/IconEventType"
import { IconPlan } from "pages/home/components/icons/FirstSteps/IconPlan"
import { IconProduct } from "pages/home/components/icons/FirstSteps/IconProduct"
import { IoMdAddCircleOutline } from "react-icons/io"

export interface Step {
  title: string
  description: string
  learnMore?: string
  buttonIcon: JSX.Element
  buttonText: string
  backgroundIcon: JSX.Element
}

export const firstStepsTotal = 3

export const firstSteps: Step[] = [
  {
    title: "Criar produto",
    description:
      "Crie seu produto digital personalizado e disponibilize-o com o Shelf. Através da integração, gerencie acessos, funcionalidades e cobranças.",
    learnMore: "products",
    buttonIcon: <IoMdAddCircleOutline />,
    buttonText: "Criar produto",
    backgroundIcon: <IconProduct />
  },
  {
    title: "Criar tipo de evento",
    description:
      "Configure os tipos de evento do seu produto para parametrizar regras de cobrança e realizar o controle de consumo das funcionalidades oferecidas.",
    learnMore: "eventTypes",
    buttonIcon: <IoMdAddCircleOutline />,
    buttonText: "Criar tipo de evento",
    backgroundIcon: <IconEventType />
  },
  {
    title: "Criar planos",
    description:
      "Crie planos flexíveis e adaptáveis às necessidades dos seus clientes. Escolha entre precificação simplificada ou modo desenvolvedor para cálculos avançados de preço.",
    learnMore: "purchasePlans",
    buttonIcon: <IoMdAddCircleOutline />,
    buttonText: "Criar planos",
    backgroundIcon: <IconPlan />
  }
]
